export function formatDuration(duration: number, interval: string): string {
  if (interval === 'month') {
    return `${duration} ${duration === 1 ? 'mês' : 'meses'}`
  } else if (interval === 'year') {
    return `${duration} ${duration === 1 ? 'ano' : 'anos'}`
  }
  return ''
}
